import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  KycPolicyDocumentDto,
  UserKycApplicationDocumentDto
} from '../../../../_core/_model/compliance';

@Component({
  selector: 'app-compliance-documents-step',
  standalone: false,
  templateUrl: './compliance-documents-step.html'
})
export class ComplianceDocumentsStep {
  @Input() uploadedDocuments: UserKycApplicationDocumentDto[] = [];
  @Input() policyDocuments: KycPolicyDocumentDto[] = [];
  @Input() draftDocumentTypeCode = '';
  @Input() draftExpiryDate = '';
  @Input() uploadBusy = false;
  @Input() deletingDocumentId: string | null = null;
  @Input() canEdit = true;

  @Output() documentTypeCodeChanged = new EventEmitter<string>();
  @Output() expiryDateChanged = new EventEmitter<string>();
  @Output() fileSelected = new EventEmitter<Event>();
  @Output() uploadClicked = new EventEmitter<void>();
  @Output() deleteClicked = new EventEmitter<UserKycApplicationDocumentDto>();

  onDocumentTypeCodeChanged(value: string): void {
    this.documentTypeCodeChanged.emit(value);
  }

  onExpiryDateChanged(value: string): void {
    this.expiryDateChanged.emit(value);
  }

  onFileSelected(event: Event): void {
    this.fileSelected.emit(event);
  }

  onUploadClicked(): void {
    this.uploadClicked.emit();
  }

  onDeleteClicked(doc: UserKycApplicationDocumentDto): void {
    this.deleteClicked.emit(doc);
  }

  trackByDoc = (_: number, item: UserKycApplicationDocumentDto) => item.id;
  trackByPolicyDoc = (_: number, item: KycPolicyDocumentDto) => item.documentTypeCode;

  getDocumentCount(documentTypeCode: string): number {
    return this.uploadedDocuments.filter(x => x.documentTypeCode === documentTypeCode).length;
  }

  get selectedPolicyDocument(): KycPolicyDocumentDto | null {
    return this.policyDocuments.find(x => x.documentTypeCode === this.draftDocumentTypeCode) || null;
  }

  getExpiryMinDate(): string | null {
    if (!this.selectedPolicyDocument?.requiresExpiryDate) {
      return null;
    }

    return new Date().toISOString().split('T')[0];
  }
}